import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PromoTrials from "../promo trials";
import { HomeController } from "../home";
import { ResultsController } from "../scope";
import { ReviewTrialController } from "../review trials";
import { PtEnrollScreen } from "../review trials/trialdetails";
import { EnrollmentController, ThankYou } from "../enroll";
import { DataNotFound, Footer, Header, Loading } from "../../components";
import { Blogs } from "../blogs";
import { Domain, environment } from "../../constants";
import Preview from "../preview trials/preview";
import Kira from "../../components/kira";
import Mosaic from "../../components/mosaic";
import Vlu from "../../components/vlu";
import EMR from "../../components/Emr";
import EHR from "../../components/Ehr";
import Conference from "../../components/Conference";
import ConnectEMR from "../../components/ConnectToEMR";
import ConferenceCheck from "../../components/ConferenceCheck";
import Records from "../../components/Records";
import DocumentUpload from "../../components/DocumentUpload";
import DocumentEnrollment from "../enroll/DocumentEnrollmentController";
import Concierge from "../../components/Concierge";
import Nurse from "../../components/Nurse";
import { log } from "../../helpers/helper";

//import Test from "../../components/Test";

const Navigation = () => {
  const location = useLocation();
  const isEmbedded = location.search && location.search.indexOf("embed=true") !== -1;

  return (
    <div>
      {isEmbedded ? (
        <Header showHeader={false} />
      ) : (
        <Header />
      )}
      <Routes>
        <Route path="/" element={<HomeController />} />
        <Route
          path="/signup"
          element={
            <Navigate
              to={
                environment === "PROD"
                  ? "/enroll/STU01009"
                  : environment === "DEV"
                  ? "/enroll/STU0001002"
                  : "/enroll/STU01006"
              }
              replace
            />
          }
        />
        <Route
          path="/participate"
          element={
            <Navigate
              to={
                environment === "PROD"
                  ? "/enroll/STU01009"
                  : environment === "DEV"
                  ? "/enroll/STU0001002"
                  : "/enroll/STU01006"
              }
              replace
            />
          }
        />
        <Route path="/results/" element={<ResultsController />} />
        <Route path="/KIRA" element={<Kira />} />
        <Route path="/kira" element={<Kira />} />
        <Route path="/mosaic" element={<Mosaic />} />
        <Route path="/MOSAIC" element={<Mosaic />} />
        <Route path="/vlu" element={<Vlu />} />
        <Route path="/VLU" element={<Vlu />} />
        <Route path="/concierge" element={<Concierge />} />
        <Route path="/nurse" element={<Nurse />} />
        <Route
          path="/medical-records/:prospect/:city"
          element={<EMR />}
        />
        <Route path="/emr" element={<EHR />} />
        <Route
          path="/upload-document/:studyId"
          element={<DocumentUpload />}
        />
        <Route
          path="/upload-enroll/:studyId"
          element={<DocumentEnrollment />}
        />
        <Route
          path="/connect-to-emr/:randomID/:study_sys_id/:domain_id/:study_number"
          element={<ConnectEMR />}
        />
        <Route
          path="/health-records/:randomID/:study_sys_id/:domain_id/:study_number"
          element={<Records />}
        />
        {/* <Route path="/test" element={<Test />} /> */}
        <Route
          path="/study/:studyId"
          element={<ReviewTrialController />}
        />
        <Route path="/thankyou/:pt" element={<ThankYou />} />
        <Route
          path="/upcoming-research/"
          element={<PtEnrollScreen />}
        />
        <Route path="/loading/" element={<Loading />} />
        <Route path="/enroll/:studyId" element={<EnrollmentController />} />
        {/* <Route path="/study/:nctid" element={<PromoTrials />} /> */}
        <Route path="/preview/:studyId" element={<Preview />} />
        <Route
          path="/conference/:patient/:appointmentId"
          element={<Conference />}
        />
        <Route
          path="/conference-check/:patient/:appointmentId"
          element={<ConferenceCheck />}
        />
        {/* <Route path="/blog/:blogid" element={<Blogs />} />
        <Route path="/blog" element={<Blogs />} /> */}
        <Route path="*" element={<DataNotFound />} />
      </Routes>
      {isEmbedded ? (
        <Footer showFooter={false} />
      ) : (
        <Footer />
      )}
    </div>
  );
};

export default Navigation;
